module.exports = __webpack_public_path__ + "static/img/8.a51425f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/8.png
// module id = FdOU
// module chunks = 0